module.exports = __webpack_public_path__ + "static/img/alimentacion.7975a80.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/markers/hq/alimentacion.png
// module id = 0nga
// module chunks = 1